<template>
  <b-modal
    id="import-modal"
    v-model="isShowModal"
    title="Chuyển TB tới kho MC tự kích hoạt"
    size="xl"
    @hide="handleClose"
  >
    <div class="modal-body">
      <div class="d-flex justify-content-between">
        <div style="width: 550px">
          <div class="form-group row">
            <label for class="col-sm-3 col-form-label">Tên kho</label>
            <div class="col-sm-7">
              <Select2
                v-model="payload.inventoryIds"
                :options="dataType"
                @change="changeLoadData"
                placeholder="Chọn loại kho để hiển thị danh sách"
              />
            </div>
          </div>
          <div class="form-group row">
            <label for class="col-sm-3 col-form-label">Ghi chú </label>
            <div class="col-sm-7">
              <textarea
                class="w-100"
                placeholder="Nhập ghi chú"
                v-model="payload.note"
                :row="3"
              ></textarea>
            </div>
          </div>
        </div>
        <div>
          <div
            v-show="idsSelected?.length"
            class="text-nowrap ml-auto text-primary cursor-pointer clean-select mt-3"
            style="font-size: 16px"
          >
            Đã chọn:
            <strong class="text-danger">{{ idsSelected.length.toLocaleString('vi-VN') }}</strong>
          </div>
          <div v-if="isUploadFile" class="mb-2" style="font-size: 16px">
            <div>
              <div style="color: green">
                Đã tải lên thành công:
                {{ successItems?.length.toLocaleString('vi-VN') || 0 }} Thiết bị
              </div>
              <div style="color: red">
                Đã tải lên thất bại:
                {{ failedItems?.length.toLocaleString('vi-VN') || 0 }} Thiết bị
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="mb-3">
        <div class="d-flex flex-row">
          <div
            class="w-100"
            style="display: flex; align-items: center; justify-content: space-between"
          >
            <div>
              <h6 class="mb-1">Danh sách TB cần chuyển kho MC tự kích hoạt</h6>
              <div class="box-search" style="padding: 0">
                <div class="form-group" v-if="!isUploadFile">
                  <SearchStaffAutocomplete
                    :maxShow="20"
                    v-model="search.categoryId"
                    :list="optionType"
                    placeholder="Chọn/Tìm kiếm thiết bị"
                  />
                </div>
                <div class="form-group" v-if="isUploadFile">
                  <input
                    type="text"
                    v-model.trim="search.categoryId"
                    class="form-control f12 hc-37 text-search"
                    placeholder="Tên thiết bị"
                  />
                </div>
                <div class="form-group">
                  <input
                    type="text"
                    v-model.trim="search.serial"
                    class="form-control f12 hc-37 text-search"
                    placeholder="Mã serial"
                  />
                </div>
                <div class="form-group form-group-action">
                  <button
                    @click="submitForm"
                    class="pt-2 mr-2 btn btn-primary hc-37"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Lọc"
                  >
                    <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
                  </button>
                  <button
                    @click="removeForm"
                    type="button"
                    class="pt-2 mr-2 btn btn-outline-light hc-37"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Bỏ lọc"
                  >
                    <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
                  </button>
                </div>
              </div>
            </div>
            <div class="mt-2">
              <div class="d-flex align-items-center" style="gap: 5px">
                <b-button variant="outline-secondary" v-if="isUploadFile" @click="handleResetData">
                  <i class="bx bx-refresh"></i>
                  Đặt lại</b-button
                >
                <b-button
                  variant="outline-primary"
                  @click="downFileTemplate"
                  :disabled="loadingDownload"
                >
                  <i class="bx bx-download"></i
                  >{{ loadingDownload ? 'Dang tải...' : 'Tải file mẫu' }}</b-button
                >
                <b-button
                  variant="outline-success"
                  @click="$refs.fileInput.click()"
                  :disabled="loadingUpFile"
                >
                  <i class="bx bxs-file-plus"></i>
                  {{ loadingUpFile ? 'Đang tải...' : 'Tải lên file' }}</b-button
                >
                <b-button
                  variant="outline-danger"
                  v-if="failedItems?.length > 0"
                  @click="downloadError"
                >
                  <i class="bx bx-download"></i>
                  {{ loadingError ? 'Đang tải...' : ' Tải thất bại' }}
                </b-button>
              </div>
            </div>

            <input
              type="file"
              ref="fileInput"
              @change="handleFileChange"
              accept=".xlsx,.xls,.csv"
              class="d-none"
            />
          </div>
        </div>
        <b-table
          :items="newDataTable"
          :fields="fields"
          striped
          hover
          sticky-header
          responsive
          :fixed="true"
          :bordered="true"
          :busy.sync="isLoading"
        >
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle" />
            </div>
          </template>
          <template #empty>
            <div class="text-center text-info my-2">Không có dữ liệu</div>
          </template>
          <template #emptyfiltered="{ emptyFilteredText }">
            <h4>{{ emptyFilteredText }}</h4>
          </template>

          <template #head(checkbox)>
            <b-form-checkbox
              v-model="selectAll"
              @change="toggleSelectAll"
              :disabled="isLoading || loadingComfirm"
            />
          </template>
          <template #cell(checkbox)="{ item }">
            <b-form-checkbox v-model="item.checked" @change="toggleSelectOne(item)" />
          </template>
        </b-table>
        <div class="d-flex justify-content-end">
          <b-pagination
            v-model="pagination.page"
            :total-rows="isUploadFile ? totalCountUpload : totalCount"
            :per-page="pagination.limit"
            @change="onChangePage"
          />
        </div>
      </div>
    </div>

    <template #modal-footer>
      <b-button variant="light" @click="handleClose"> Hủy </b-button>
      <b-button
        :disabled="loadingComfirm || idsSelected?.length <= 0"
        variant="primary"
        @click="handleConfirm"
      >
        {{ loadingComfirm ? 'Đang lưu...' : 'Xác nhận' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
  import { showMess } from '@/config/utils'
  import { DeviceService } from '@/services/device.service'
  import SearchStaffAutocomplete from '@/components/cskh/SearchStaffAutocomplete.vue'

  export default {
    name: 'PopupList',
    props: ['onLoad'],
    components: {
      SearchStaffAutocomplete,
    },
    data() {
      return {
        isShowModal: false,
        loadingComfirm: false,
        isLoading: false,
        selectAll: false,
        dataTable: [],
        payload: {
          inventoryIds: null,
          note: '',
        },
        dataType: [],
        idsSelected: [],
        maxtSelect: 0,
        totalCount: 0,
        pagination: {
          page: 1,
          total: 0,
          limit: 15,
        },
        optionType: [],
        search: {
          serial: '',
          categoryId: '',
        },
        activeSearch: {
          serial: '',
          categoryId: '',
        },
        loadingDownload: false,
        loadingUpFile: false,
        isUploadFile: false,
        loadingError: false,
        importedData: [],
        fields: [
          {
            key: 'checkbox',
            label: 'Chọn',
            tdClass: 'text-center',
            thClass: 'text-center',
            thStyle: { width: '40px' },
          },

          {
            key: 'serial',
            label: 'Serial',
          },
          {
            key: 'categoryName',
            label: 'Tên TB',
            thStyle: { 'min-width': '200px', width: '200px' },
          },
          {
            key: 'note',
            label: 'Ghi chú',
          },
        ],
      }
    },

    created() {
      this.getDataType()
    },
    computed: {
      successItems() {
        return this.importedData?.correctList || []
      },
      failedItems() {
        return this.importedData?.errorList || []
      },
      filteredSuccessItems() {
        if (!this.successItems.length) return []

        return this.successItems.filter(item => {
          const matchSerial = this.activeSearch.serial
            ? item.serial?.toLowerCase().includes(this.activeSearch.serial.toLowerCase())
            : true

          const matchCategory = this.activeSearch.categoryId
            ? item.categoryId === this.activeSearch.categoryId ||
              item.categoryName?.toLowerCase().includes(this.activeSearch.categoryId.toLowerCase())
            : true

          return matchSerial && matchCategory
        })
      },
      paginatedSuccessItems() {
        if (!this.filteredSuccessItems.length) return []
        const start = (this.pagination.page - 1) * this.pagination.limit
        const end = start + this.pagination.limit
        return this.filteredSuccessItems.slice(start, end).map(item => ({
          ...item,
          checked: this.idsSelected.includes(item.id),
        }))
      },
      newDataTable() {
        if (this.isUploadFile) {
          return this.paginatedSuccessItems
        }
        return this.dataTable
      },
      totalCountUpload() {
        if (this.isUploadFile) {
          return this.successItems.length
        }
        return this.pagination.total
      },
    },
    methods: {
      handleResetData() {
        this.importedData = []
        this.isUploadFile = false
        this.pagination.page = 1
        this.idsSelected = []
        this.fetchData()
      },
      handleFileChange(event) {
        const file = event.target.files[0]
        if (file) {
          // TODO: Implement file processing logic
          this.processFile(file)
        }
      },
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        if (this.isUploadFile) {
          this.activeSearch = {
            serial: this.search.serial,
            categoryId: this.search.categoryId,
          }
        }
        if (!this.isUploadFile) {
          await this.fetchData()
        }
      },
      async removeForm() {
        this.search = {
          serial: '',
          categoryId: '',
        }
        this.activeSearch = {
          serial: '',
          categoryId: '',
        }
        this.pagination = {
          page: 1,
          total: 0,
          limit: 15,
        }
        if (!this.isUploadFile) {
          await this.fetchData()
        }
      },
      // show modal
      show(optionTypeData) {
        this.isShowModal = true
        this.payload.inventoryIds = this.dataType[0]?.id || null
        if (this.payload?.inventoryIds) {
          this.fetchData()
        }
        this.optionType = optionTypeData || []
      },
      changeLoadData(item) {
        this.payload.inventoryIds = item
        this.onClearSelect()
        this.fetchData()
      },

      async processFile(file) {
        this.loadingUpFile = true
        this.isLoading = true
        try {
          // Example processing
          const formData = new FormData()
          formData.append('file', file)
          formData.append('inventoryId', this.payload.inventoryIds)
          const res = await DeviceService.UploadFileMCselActivate(formData)

          if (res.code === 1000) {
            this.importedData = {
              correctList: res.data?.correctList || [],
              errorList: res.data?.errorList || [],
            }
            this.idsSelected = res.data?.correctList?.map(item => item.id) || []

            showMess(
              this,
              'Đã tải lên',
              `Tải lên thành công: ${res.data?.correctList?.length || 0} |
          Tải lên thất bại: ${res.data?.errorList?.length || 0}`,
              'success',
              'b-toaster-top-right',
              5 * 60 * 60
            )
            this.isUploadFile = true
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Tải lên thất bại',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.loadingUpFile = false
          this.isLoading = false
          this.resetFileInput()
        }
      },

      async downloadError() {
        this.loadingError = true
        try {
          await DeviceService.DownloadErrorMCselActivate(this.failedItems || [])
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.loadingError = false
        }
      },

      resetFileInput() {
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = ''
        }
      },

      // toggleSelectAll() {
      //   const value = this.selectAll
      //   for (const item of this.dataTable) {
      //     item.checked = value
      //     const id = item.id
      //     const index = this.idsSelected.indexOf(id)
      //     index >= 0 && this.idsSelected.splice(index, 1)
      //     if (value) {
      //       !this.idsSelected.includes(id) && this.idsSelected.push(id)
      //     }
      //   }
      //   this.cleanSelectIfOver()
      // },
      // toggleSelectOne(item) {
      //   const id = item.id
      //   const index = this.idsSelected.indexOf(id)
      //   index >= 0 && this.idsSelected.splice(index, 1)
      //   if (item.checked) {
      //     !this.idsSelected.includes(id) && this.idsSelected.push(id)
      //   }
      //   this.selectAll = this.dataTable.every((item) => item.checked)
      //   this.cleanSelectIfOver()
      // },
      toggleSelectAll() {
        const value = this.selectAll
        if (this.isUploadFile) {
          const currentPageItems = this.paginatedSuccessItems
          currentPageItems.forEach(item => {
            const id = item.id
            const index = this.idsSelected.indexOf(id)
            if (value) {
              if (index === -1) this.idsSelected.push(id)
            } else {
              if (index >= 0) this.idsSelected.splice(index, 1)
            }
          })
        } else {
          for (const item of this.dataTable) {
            item.checked = value
            const id = item.id
            const index = this.idsSelected.indexOf(id)
            index >= 0 && this.idsSelected.splice(index, 1)
            if (value) {
              !this.idsSelected.includes(id) && this.idsSelected.push(id)
            }
          }
        }
        this.cleanSelectIfOver()
      },
      toggleSelectOne(item) {
        const id = item.id
        const index = this.idsSelected.indexOf(id)
        index >= 0 && this.idsSelected.splice(index, 1)
        if (item.checked) {
          !this.idsSelected.includes(id) && this.idsSelected.push(id)
        }

        if (this.isUploadFile) {
          this.selectAll = this.paginatedSuccessItems.every(item =>
            this.idsSelected.includes(item.id)
          )
        } else {
          this.selectAll = this.dataTable.every(item => item.checked)
        }
        this.cleanSelectIfOver()
      },
      onClearSelect() {
        this.idsSelected = []
        this.selectAll && (this.selectAll = false)
        this.dataTable.forEach(item => {
          item.checked && (item.checked = false)
        })
      },
      cleanSelectIfOver() {
        this.idsSelected.length > this.maxtSelect &&
          (() => {
            this.idsSelected = this.idsSelected.slice(-this.maxtSelect)
          })()
      },
      async getDataType() {
        try {
          const res = await DeviceService.getOptionDataType({
            type: 'E_COMMERCE_WAREHOUSE',
          })
          if (res.code === 1000) {
            this.dataType = res.data?.map(i => ({
              id: i.id,
              text: i.name,
            }))
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Lỗi không tìm thấy dữ liệu',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (error) {
          showMess(
            this,
            'Error',
            error.message || 'Lỗi không tìm thấy dữ liệu',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },

      async onChangePage(pageIndex) {
        this.pagination.page = pageIndex
        if (!this.isUploadFile) {
          await this.fetchData()
        }
      },

      // đóng modal
      handleClose() {
        this.isShowModal = false
        this.dataTable = []
        this.isUploadFile = false
        this.importedData = []
        this.idsSelected = []
      },
      // cài đặt lại trạng thái state

      async downFileTemplate() {
        this.loadingDownload = true
        try {
          await DeviceService.dowFileMCselActivate({})
        } catch (error) {
          showMess(
            this,
            'Error',
            error.message || 'Tải xuống file mẫu thất bại',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.loadingDownload = false
        }
      },

      async fetchData() {
        try {
          this.isLoading = true
          if (this.search.categoryId === '0') delete this.search.categoryId

          const params = {
            ...(this.payload?.inventoryIds && {
              inventoryIds: [this.payload.inventoryIds],
            }),
            status: ['AVAILABILITY', 'USED'],
            limit: this.pagination.limit,
            page: this.pagination.page,
            ...this.search,
          }
          const res = await DeviceService.listDevice(params)
          if (res.code === 1000) {
            // Lấy danh sách mới
            const newDevices = res.data?.devices || []

            // Đồng bộ trạng thái checked với các item đã được chọn trước đó
            this.dataTable = newDevices.map(item => {
              const selectedItem = this.idsSelected.find(selectedId => selectedId === item.id)
              if (selectedItem) {
                return {
                  ...item,
                  checked: true,
                }
              }
              return {
                ...item,
                checked: false,
              }
            })

            this.pagination.total = res.data?.count || 0
            this.totalCount = res.data?.count || 0
            this.maxtSelect = res.data.count || 0

            // Cập nhật lại trạng thái selectAll
            if (this.dataTable.length > 0) {
              this.selectAll = this.dataTable.every(item => item.checked)
            } else {
              this.selectAll = false
            }
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Lỗi không tìm thấy dữ liệu',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (error) {
          showMess(
            this,
            'Error',
            error.message || 'Lỗi không tìm thấy dữ liệu',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },

      // xac nhận

      async handleConfirm() {
        this.loadingComfirm = true
        try {
          const res = await DeviceService.ComfirmECommerce({
            deviceIds: this.idsSelected || [],
            note: this.payload.note || '',
          })
          if (res.code === 1000) {
            showMess(
              this,
              'Success',
              res.message || 'Xác nhận thành công',
              'success',
              'b-toaster-top-right',
              5 * 60 * 60
            )
            this.$emit('onLoad')
            this.isShowModal = false
            this.onClearSelect()
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Lỗi xác nhận',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (error) {
          showMess(this, 'Error', error.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.loadingComfirm = false
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .modal-body {
    padding-top: 0;
    max-height: 70vh;
    height: 70vh;
    overflow-y: auto;
    .radio-group {
      display: flex;
      justify-items: center;
    }
  }
  :deep(.modal-xl) {
    max-width: 1200px;
  }
  :deep(.form-control-sm) {
    height: 37px !important;
    padding: 0.375rem 0.75rem;
  }
</style>
